import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.priscriptionlist, { type, payload }) {
    switch (type) {
        case types.PRISCRIPTIONLIST_REQUEST:
            return {
                ...initialState.priscriptionlist,
                isLoading: true,
                isStatus: 'request',
                request: payload,
                successResponse: {},
                errorResponse: {}
            };
        case types.PRISCRIPTIONLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isStatus: 'success',
                successResponse: payload,
                request: {}
            };
        case types.PRISCRIPTIONLIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                successResponse: {},
                errorResponse: payload,
                request: {}
            };
        default:
            return state;
    }
}